import React, { useState, useEffect, useId } from "react";
import TextInfo, {
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_COLOR,
} from "@gc-npm/components.text";
// import { useRouter } from "next/router";
import ChevronIcon from "@/component/ChevronIcon";
import { useSelector } from "react-redux";
import EnumFilter from "./EnumFilter/EnumFilter";
import RangeFilter from "./RangeFilter/RangeFilter";
import RadioFilter from "./RadioFilter/RadioFilter";
import ButtonFilter from "./ButtonFilter/ButtonFilter";

import styles from "./style";
import { COLORS } from "@gc-npm/utils.enums.colors";

const Filters = ({ filters, mobile }) => {
  const filterIdPrefix = useId();
  // const router = useRouter();
  const [visibleFilters, setVisibleFilters] = useState([]);
  const [visibleFiltersOrder, setVisibleFiltersOrder] = useState(true);
  //const { selectedFilters, id } = useSelector((state) => state.products);
  const { selectedFilters, id } = useSelector((state) => state.devicesList);
  const { showDeviceCategoryFilter } = useSelector((state) => state.pageInfo);

  useEffect(() => {
    if (selectedFilters) {
      const updatedFilters = {};
      const addedKeys = new Set();

      Object.keys(selectedFilters).forEach((key) => {
        const newKey = key.toLowerCase().replace("min", "").replace("max", "");

        if (!addedKeys.has(newKey)) {
          updatedFilters[newKey] = selectedFilters[key];
          addedKeys.add(newKey);
        }
      });

      const variableNamesArray = Object.keys(updatedFilters);

      variableNamesArray.push("category");

      setVisibleFilters(variableNamesArray);
    }
  }, [selectedFilters]);

  const toggleFilter = (filterId) => {
    if (visibleFilters.includes(filterId)) {
      setVisibleFilters(visibleFilters.filter((id) => id !== filterId));
    } else {
      setVisibleFilters([...visibleFilters, filterId]);
    }
  };

  const isFilterVisible = (filterId) => visibleFilters.includes(filterId);

  const toggleFilterOrder = () => {
    setVisibleFiltersOrder(!visibleFiltersOrder);
  };

  const renderFilter = (filter, index) => {
    return (
      <div
        key={filter.id}
        style={{ backgroundColor: COLORS.MOVISTAR_BLUE }}
        className="filterContainer"
        data-cy={`filter filter-${filter.id
          } filter-type-${filter.type.toLowerCase()}`}
      >
        {
          filter.id !== "category" ? (
            <button
              type="button"
              onClick={() => toggleFilter(filter.id)}
              className="filterTitle"
              aria-expanded={isFilterVisible(filter.id)}
              aria-controls={`${filterIdPrefix}-filter-${filter.id}`}
            >
              <TextInfo
                text={filter.name}
                size={TEXT_SIZE.SUBTITLE1}
                color={TEXT_COLOR.GREY_600}
                fontType={TEXT_FONT_WEIGHT.REGULAR}
                cydata={`filterTitle-${filter.id}`}
              />
              <ChevronIcon
                open={isFilterVisible(filter.id)}
                cydata={`filterChevron-${filter.id}`}
              />
            </button>
          ) : (
            <TextInfo
              className="filterTitle"
              text={filter.name}
              size={TEXT_SIZE.SUBTITLE1}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={TEXT_FONT_WEIGHT.BOLD}
              cydata={`filterTitle-${filter.id}`}
            />
          )}

        <div
          className={`filtersContent ${isFilterVisible(filter.id) ? "opened" : ""
            }`}
          data-cy={`filtersContentOpen-${filter.id}`}
          id={`${filterIdPrefix}-filter-${filter.id}`}
          hidden={!isFilterVisible(filter.id)}
        >
          {(filter.type === "ENUM" || filter.type === "RANGE_AS_ENUM") && (
            <EnumFilter filter={filter} mobile={mobile} highlighted={filter.id === "category"} disableCollapse={filter.id === "category"} hideCount={filter.id === "tags"}/>
          )}
          {filter.id === "category" && (
            <hr />
          )}
          {filter.id === "category" && index < filters.length - 1 && (
            <TextInfo
              className="filterTitle"
              text={"Otros filtros"}
              size={TEXT_SIZE.SUBTITLE1}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              fontType={TEXT_FONT_WEIGHT.BOLD}
              cydata={`filterTitle-${filter.id}`}
            />
          )}
          {filter.type === "RANGE" && (
            <RangeFilter filter={filter} mobile={mobile} />
          )}

        </div>
      </div>)
  };

  return (
    <>
      {mobile && (
        <div className="filterContainer">
          <button
            type="button"
            onClick={() => toggleFilterOrder()}
            className="filterTitle"
            aria-expanded={visibleFiltersOrder}
            aria-controls={`${filterIdPrefix}-filter-order`}
          >
            <TextInfo
              text="Ordenar por"
              size={TEXT_SIZE.CAPTION1}
              color={TEXT_COLOR.GREY5}
              fontType={TEXT_FONT_WEIGHT.REGULAR}
            />
            <ChevronIcon open={visibleFiltersOrder} />
          </button>
          <div
            className={`filtersContent ${visibleFiltersOrder ? "opened" : ""}`}
            id={`${filterIdPrefix}-filter-order`}
            hidden={!visibleFiltersOrder}
          >
            <RadioFilter />
          </div>
        </div>
      )}
      {!mobile && (
        <ButtonFilter />
      )}
      {filters
        .filter((filtered) => {
          return (
            filtered.id !== "offerCategory" &&
            filtered.id !== "customTags" &&
            (showDeviceCategoryFilter || filtered.id !== "category")
          );
        })
        .map((filter, index) => renderFilter(filter, index))}
      <style jsx>{styles}</style>
    </>
  );
};

export default Filters;
